import { render, staticRenderFns } from "./ArrowTickIcon.vue?vue&type=template&id=00b0dcca&"
import script from "./ArrowTickIcon.vue?vue&type=script&lang=js&"
export * from "./ArrowTickIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports